import { useState } from "react";
import { ThumbsUp } from "lucide-react";
import { toast } from "sonner";
import { voteForVoice, extractApiError } from "@/lib/api";

export const VoteButton = ({ voice }) => {
  const [votes, setVotes] = useState(voice.votes ?? 0);
  const [voted, setVoted] = useState(Boolean(voice.voted));
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    setBusy(true);
    try {
      const res = await voteForVoice(voice.id);
      setVotes(res.votes);
      setVoted(res.voted);
      if (res.voted) toast.success("Counted — Vic sees the leaderboard every Sunday.");
    } catch (err) {
      toast.error(extractApiError(err, "Could not record vote."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid="voice-vote"
      aria-pressed={voted}
      onClick={toggle}
      disabled={busy}
      title={voted ? "Remove my vote" : "I want this conversation"}
      className={`inline-flex items-center gap-2 px-3 py-2 text-xs font-medium border transition-colors ${
        voted
          ? "bg-[#0A192F] border-[#0A192F] text-white"
          : "border-slate-300 text-slate-600 hover:border-[#0A192F] hover:text-[#0A192F]"
      }`}
    >
      <ThumbsUp className={`w-3.5 h-3.5 ${voted ? "fill-current" : ""}`} />
      {voted ? "Wanted" : "I want this one"}
      <span data-testid="voice-vote-count" className={voted ? "text-white/70" : "text-slate-400"}>· {votes}</span>
    </button>
  );
};

export default VoteButton;
